module.exports = __webpack_public_path__ + "img/yoshi_lee.91f2346a.jpg";